// Dummy data for 10 major crops - REALISTIC Indian mandi rates 
const mandiPrices = [
  { id: 1, crop: "Wheat", state: "Punjab", price: 2275, unit: "quintal", change: "+15", market: "Khanna" },
  { id: 2, crop: "Rice", state: "Telangana", price: 2450, unit: "quintal", change: "-10", market: "Jangaon" },
  { id: 3, crop: "Sugarcane", state: "UP", price: 350, unit: "quintal", change: "+5", market: "Meerut" },
  { id: 4, crop: "Cotton", state: "Maharashtra", price: 7200, unit: "candy", change: "+120", market: "Akola" },
  { id: 5, crop: "Onion", state: "Maharashtra", price: 1850, unit: "quintal", change: "-80", market: "Lasalgaon" },
  { id: 6, crop: "Potato", state: "UP", price: 1250, unit: "quintal", change: "+30", market: "Agra" },
  { id: 7, crop: "Tomato", state: "Karnataka", price: 950, unit: "quintal", change: "+45", market: "Kolar" },
  { id: 8, crop: "Maize", state: "Bihar", price: 1850, unit: "quintal", change: "0", market: "Hajipur" },
  { id: 9, crop: "Groundnut", state: "Gujarat", price: 5250, unit: "quintal", change: "-25", market: "Rajkot" },
  { id: 10, crop: "Mustard", state: "Rajasthan", price: 4850, unit: "quintal", change: "+60", market: "Alwar" }
];

export default mandiPrices;
